import React, { useState, useEffect, useRef } from 'react'
import SbEditable from "storyblok-react"
import RichText from 'src/utils/RichText'
import Label from 'src/components/Label'
import Heading from 'src/components/Heading'
import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/outline'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const Faq = (props) => {

    const [height, setHeight] = useState(0)
    const ref = useRef(null)

    useEffect(() => {
        setHeight(ref.current.clientHeight)
    }, [])

    return (
        <Disclosure as="div" className="pt-4 last:border-b">
            {({ open }) => (
            <>
                <dt className="text-lg">
                <Disclosure.Button className="group text-left w-full flex justify-between items-start">
                    <Heading size="h3" className={classNames(open ? 'text-pink' : 'text-darkblue', 'font-display uppercase lg:text-xl text-lg group-hover:text-pink mb-0 duration-500')}>{props.title}</Heading>
                    <span className="ml-6 h-7 flex items-center">
                    <ChevronDownIcon
                        className={classNames(open ? '-rotate-180 text-pink' : 'rotate-0 text-darkblue', 'h-6 w-6 transform transition-all duration-500 ease-in-out group-hover:text-pink')}
                        aria-hidden="true"
                    />
                    </span>
                </Disclosure.Button>
                </dt>
                <dd className="mt-2 pr-12">
                    <div style={{ maxHeight: open ? height : 0 }} className={classNames(open ? 'mb-4' : 'mb-0', 'overflow-hidden transform transition-all duration-500 ease-in-out')}>
                        <div className="font-body prose leading-6 text-gray" ref={ref}>
                            <RichText>{props.content}</RichText>
                        </div>
                    </div>
                </dd>
            </>
            )}
        </Disclosure>
    )
};

const OffsetSupportingText = ({blok}) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="relative bg-white py-16 sm:py-20">
                <div className="flex flex-row flex-wrap max-w-7xl mx-auto">
                    <div className="w-full lg:w-5/12 px-4 sm:px-6 mb-6">
                        <Label className="text-pink mb-2">{blok.label}</Label>
                        <Heading size="h1" as={blok.title_h_tag ? blok.title_h_tag : 'h2'} className="text-darkblue max-w-sm">{blok.title}</Heading>
                        <div className="max-w-sm font-body text-gray prose leading-6"><RichText>{blok.content}</RichText></div>
                    </div>
                    <div className="w-full lg:w-7/12 px-4 sm:px-6 mx-auto">
                        <dl v-for="item in items" className="mt-1 space-y-1 divide-y divide-gray first:border-t first:border-gray last:pb-1">
                            {blok.items.map((faq, index) => (
                                <Faq {...faq} key={index}></Faq>
                            ))}
                        </dl>
                    </div>
                </div>
            </div>
        </SbEditable>
  )
};

export default OffsetSupportingText;
